import {
  Container,
  DiagnosisSpinnerWrapper,
  DiagnosisSpinner,
  StatusTitle,
  StatusSubtitle,
  RetryButton
} from './styles'

export function Computing ({ failed = false, onRetry }) {
  if (failed) {
    return (
      <Container>
        <StatusTitle style={{ color: '#c0392b' }}>Error en el diagnóstico</StatusTitle>
        <StatusSubtitle>
          La IA no pudo procesar las imágenes. Por favor, volvé al paso anterior e intentá de nuevo.
        </StatusSubtitle>
        {onRetry && (
          <RetryButton onClick={onRetry}>
            Volver e intentar de nuevo
          </RetryButton>
        )}
      </Container>
    )
  }

  return (
    <Container>
      <DiagnosisSpinnerWrapper>
        <DiagnosisSpinner />
      </DiagnosisSpinnerWrapper>

      <StatusTitle> Procesando imágenes... </StatusTitle>

      <StatusSubtitle> Aguarde mientras nuestra IA analiza los estudios </StatusSubtitle>
    </Container>
  )
}

export default Computing
